import { useTranslation } from 'react-i18next'

import { Tab } from 'components/Tabs'
import { GeneralFormEdit } from 'features/inventory/ad-unit/forms/GeneralForm'
import { AdUnitForForm } from 'features/inventory/ad-unit/forms/GeneralForm/hooks/useGetAdUnit'
import PrebidStackForm from 'features/inventory/ad-unit/forms/PrebidStackForm'
import { PriceGeniusCommonForm } from 'features/inventory/ad-unit/forms/PriceGeniusForm'
import RefresherForm from 'features/inventory/ad-unit/forms/RefresherForm'
import UnfilledRecoveryForm from 'features/inventory/ad-unit/forms/UnfilledRecoveryForm'
import ViewabilityToolsForm from 'features/inventory/ad-unit/forms/ViewabilityToolsForm'
import { useAbility } from 'providers/casl'
import { generateSelector } from 'providers/product-fruits/utils'
import { ProductTab } from 'types/productTab'

export const useProductTabs = (adUnit?: AdUnitForForm): Tab<ProductTab>[] => {
  const ability = useAbility()
  const { t } = useTranslation('features/adUnit')
  const { t: tProduct } = useTranslation('features/product')

  const canAccess = ability.can('access', 'AdUnitPage-edit')

  return [
    {
      disabled: !canAccess,
      element: 'general',
      label: t('edit.tabs.general'),
      page: <GeneralFormEdit />,
      productFruitsSelector: generateSelector({ step: 1, tour: 2 }),
    },
    {
      authorized: 'Product-prebidStack',
      disabled: !canAccess || !ability.can('access', 'Product-prebidStack'),
      element: 'prebid-stack',
      label: tProduct('product.prebidStack'),
      page: <PrebidStackForm />,
    },
    {
      authorized: 'Product-refresher',
      disabled: !canAccess || !ability.can('access', 'Product-refresher'),
      element: 'refresher',
      label: tProduct('product.refresher'),
      page: <RefresherForm />,
    },
    {
      authorized: 'Product-viewabilityTools',
      disabled:
        !canAccess || !ability.can('access', 'Product-viewabilityTools') || adUnit?.outOfPage,
      element: 'viewability-tools',
      label: tProduct('product.viewabilityTools'),
      page: <ViewabilityToolsForm />,
      tooltip: adUnit?.outOfPage ? { content: t('edit.tabs.viewabilityTools.tooltip') } : undefined,
    },
    {
      authorized: 'Product-priceGenius',
      disabled: !canAccess || !ability.can('access', 'Product-priceGenius'),
      element: 'price-genius',
      label: tProduct('product.priceGenius'),
      page: <PriceGeniusCommonForm />,
    },
    {
      authorized: 'Product-unfilledRecovery',
      disabled: !canAccess || !ability.can('access', 'Product-unfilledRecovery'),
      element: 'unfilled-recovery',
      label: tProduct('product.unfilledRecovery'),
      page: <UnfilledRecoveryForm />,
    },
  ]
}
